import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const PinSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M21.2173 10C21.2173 17 12.2173 23 12.2173 23C12.2173 23 3.21729 17 3.21729 10C3.21729 7.61305 4.1655 5.32387 5.85332 3.63604C7.54115 1.94821 9.83034 1 12.2173 1C14.6042 1 16.8934 1.94821 18.5812 3.63604C20.2691 5.32387 21.2173 7.61305 21.2173 10Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.2173 13C13.8741 13 15.2173 11.6569 15.2173 10C15.2173 8.34315 13.8741 7 12.2173 7C10.5604 7 9.21729 8.34315 9.21729 10C9.21729 11.6569 10.5604 13 12.2173 13Z'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const PinIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={PinSvg} color='#3F3D56' {...props} />
);
